import React from 'react'

function TrackCard ({ children }) {
  return (
    <div className='overflow-hidden bg-white rounded-lg shadow-lg'>
      {children}
    </div>
  )
}

export default TrackCard
